import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { DEFAULT_SIZE } from './config';
import type { TSpacerVertical } from './models';

export const SpacerVertical: FC<TSpacerVertical> = props => {
    const { className, inlineTag, size = DEFAULT_SIZE, styles = {}, separator, ...rest } = props;

    const classNames = cn(styles.block, styles[`size_${size}`], className);
    const Tag = inlineTag ? 'span' : 'div';

    return (
        <Tag className={classNames} {...rest}>
            {separator}
        </Tag>
    );
};
